import ajax from "@/libs/Ajax";

// 后台命名空间
const NAME_SPACE = "/sys/notice";

export default {
  // 保存通知
  doSave(params){
    return ajax.post(`${NAME_SPACE}/saveNotice`, params)
  },
  // 查询通知
  doQuery(params) {
    return ajax.get(`${NAME_SPACE}/queryNotice`, {params})
  },
  // 获取单个通知
  doGet(uuid) {
    return ajax.get(`${NAME_SPACE}/get/${uuid}`)
  },
  // 删除单个通知
  doDelete(uuid) {
    return ajax.delete(`${NAME_SPACE}/deleteNotice/${uuid}`)
  },
  // 删除多个通知
  doDeletes(uuids){
    return ajax.delete(`${NAME_SPACE}/deleteNotices/${uuids}`)
  },
  // 获取系统通知主题集合
  getNoticeCodes(){
    return ajax.get(`${NAME_SPACE}/getNoticeCodes`)
  },
  // 获取用户列表
  getUserList() {
    return ajax.get(`${NAME_SPACE}/getUserList`);
  },
  // 获取已通知用户列表
  getNoticeUsers(uuid){
    return ajax.get(`${NAME_SPACE}/getNoticeUsers/${uuid}`)
  },
  // 批量设置通知用户
  doSeleNoticeUser(params) {
    return ajax.get(`${NAME_SPACE}/doSeleNoticeUser`, {params})
  },
  // 设置单个通知用户
  doSaveNoticeUser(params){
    return ajax.get(`${NAME_SPACE}/doSaveNoticeUser`, {params})
  },
  // 更新通知状态
  changeStat(params){
    return ajax.post(`${NAME_SPACE}/updateNoticeStat`, params)
  },
  // 查询通知人员列表信息
  queryNoticeUsersInfo(params){
    return ajax.get(`${NAME_SPACE}/queryNoticeUsersInfo`, {params});
  },
  // 通知保存人员通知方式
  submitNoticeUserInfo(params){
    return ajax.post(`${NAME_SPACE}/submitNoticeUserInfo`, params)
  }
};